import React, { useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { sendLinkToCustomer, getPresignedURL, uploadFileUsingPresignedURL, updateUploadFilesToAttachments } from "../../services/common";

const FileUploadModal = (props) => {

    const [applicationId] = React.useState(props.applicationid)
    const [vendor] = React.useState(props.vendor);
    const [image, setImage] = React.useState([]);
    const [signature, setSignature] = React.useState([]);
    const [idproof, setIdproof] = React.useState([]);
    const [ecgreport, setEcgreport] = React.useState([]);

    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const [messageSnacks, setMessageSnacks] = React.useState("");

    useEffect(() => {
        setTimeout(function () {
            setShowSnackbar(false)
        }, 3000);
    },[showSnackbar])

    const sendLink = async () => {
        let res = await sendLinkToCustomer(applicationId);
        console.log("res ", res)
        if (res && res.errorStatus && res.errorResponse) {
            setShowSnackbar(true);
            setMessageSnacks(res.errorResponse.data);
        }
        if (res == 200) {
            setShowSnackbar(true);
            setMessageSnacks("Message Sent Successfully");
        }
    }

    const slugify = (text) => {
        return text.toString().toLowerCase()
          .replace(/\s+/g, '-');           // Replace spaces with -
      }
    const sendTypeOfFile = (index) => {
        switch(index) {
            case 0 : return "CUSTOMER_PHOTO"; 
            case 1 : return "CUSTOMER_SIGNATURE"; 
            case 2 : return "ID"; 
            case 3 : return "CARDIAC"; 
            default: return null; 
        }
    }

    const onCloseModal = () => {
        props.onHide();
    }

    const submitFiles = async () => {
        let arrayOfFiles = [];
        if(image != []) arrayOfFiles.push(image[0])
        if(signature != []) arrayOfFiles.push(signature[0])
        if(idproof != []) arrayOfFiles.push(idproof[0])
        if(ecgreport != []) arrayOfFiles.push(ecgreport[0])

        console.log("arrayOfFiles :: ",arrayOfFiles)
        let i = -1;
        let uploadAnyFile = false;
        for(i = 0; i<arrayOfFiles.length; i++){
            if(arrayOfFiles[i] != undefined){
                let fileDetails = {
                   file: arrayOfFiles[i],
                   fileType: arrayOfFiles[i].type,
                   fileName: arrayOfFiles[i].name,
                   signedUrl: "",
                   fileIdentifier: "",
                   documentType: sendTypeOfFile(i),
                   vendor: slugify(vendor),
                   applicationId : applicationId
               }
       
               console.log(" fileDetails :: " + fileDetails)
       
               let responseOfGetPresignedURL = await getPresignedURL(fileDetails);
               if (responseOfGetPresignedURL.success) {
                   console.log("Success" + responseOfGetPresignedURL.response);
                   fileDetails.signedUrl = responseOfGetPresignedURL.signedURL;
                   fileDetails.fileIdentifier = responseOfGetPresignedURL.fileIdentifier;
                   let responseOfUploadFileUsingPresignedURL = await uploadFileUsingPresignedURL(fileDetails.signedUrl,fileDetails.file, fileDetails.fileType);
                   if (responseOfUploadFileUsingPresignedURL && responseOfUploadFileUsingPresignedURL.errorStatus && responseOfUploadFileUsingPresignedURL.errorResponse) {
                       setShowSnackbar(true);
                       setMessageSnacks("File Upload Failed");
                   }
                   if (responseOfUploadFileUsingPresignedURL == 200) {
                       let responseOfUpdateUploadFilesToAttachments = await updateUploadFilesToAttachments(fileDetails);
                           if(!responseOfUpdateUploadFilesToAttachments.success){
                                setShowSnackbar(true);
                                setMessageSnacks(responseOfUpdateUploadFilesToAttachments.response);
                           }else{
                                uploadAnyFile = true;
                           }
                   }
               }
               if (responseOfGetPresignedURL.errorStatus && responseOfGetPresignedURL.errorResponse) {
                   setShowSnackbar(true);
                   setMessageSnacks(responseOfGetPresignedURL.errorResponse.data.response);
               }
            }
        }
        if(i > 0 && uploadAnyFile){
            setTimeout(() => {
                onCloseModal()
            },3000)
            setShowSnackbar(true);
            setMessageSnacks("File Uploaded and Saved Successfully");
        }else{
            setShowSnackbar(true);
            setMessageSnacks("No File is selected");
        }
    }


    const getFileList = (files, fileList) => {
        if (files) {
            Object.keys(files).forEach(newFile => {
                fileList.push(files[newFile]);
            });
        }
        return fileList;
    }


    const handleFieldChange = async (event) => {
        event.preventDefault();
        let fileList = [];
        const { name, value, files } = event.currentTarget;
        let res = {};
        if (files) {
            fileList = getFileList(files, fileList);
        }
        event.target.value = ''
        switchCase(name, value, fileList, res);
    }

    const switchCase = (name, value, files, guid) => {
        console.log("files", files)
        switch (name) {
            case 'photo':
                setImage(image.concat(files))
                break;
            case 'signature':
                setSignature(signature.concat(files))
                break;
            case 'idproof':
                setIdproof(idproof.concat(files))
                break;
            case 'ecgreport':
                setEcgreport(ecgreport.concat(files))
                break;
            default:
                break;
        }
    }

    const remove = (type) => {
        switch (type) {
            case 'image': setImage([]); break;
            case 'signature': setSignature([]); break;
            case 'idproof': setIdproof([]); break;
            case 'ecgreport': setEcgreport([]); break;
            default: console.log("no type selected"); break;
        }
    }

    return (
        <div>
            <Modal
                animation={false}
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                onHide={() => onCloseModal()}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Customer Information
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: "450px", padding: '5px' }}>


                    <div className="send-link-badge width-30 m-auto m-t-20 cursor-pointer temp">
                        <div className="display-flex justify-content-center" onClick={() => sendLink()}>
                            <div className="p-l-5 p-r-5">
                                <i className="fa fa-whatsapp"></i>
                            </div>
                            <div>
                                Send Link
                            </div>
                        </div>
                    </div>
                    {
                        showSnackbar &&
                        <div className="center-div w-100">
                              <div className="snackbar show">
                                {messageSnacks}
                            </div>
                        </div> 
                    }


                    {/* <Row className="p-t-4">
                        <Col xs={6} md={6}>
                            <span className="font-size-xsm">Reason for Physical MER<span className="red-color">*</span></span>
                            <Form.Control as="select" name="id_proof_type" >
                                <option value="">Select Id Proof</option>
                                <option value="Due to non availability of Doctor">Due to non availability of Doctor</option>
                                <option value="Network/Connectivity issue">Network/Connectivity issue</option>
                                <option value="Customer not willing to do video call (Done with Physical MER)">Customer not willing to do video call (Done with Physical MER)</option>
                                <option value="Customer not willing to talk to Doctor">Customer not willing to talk to Doctor</option>
                                <option value="Driving license">Driving license</option>
                                <option value="Customer requested for complete DigiMER later">Customer requested for complete DigiMER later</option>
                            </Form.Control>
                        </Col>
                    </Row> */}


{/* 
                    <div className="display-flex justify-content-space-around m-t-10">
                        <div className="width-48">

                            <div className="w-100">
                                <div className="w-100 file-upload-header">
                                    Customer Photo
                                </div>
                                {
                                    image && image.length > 0 ?
                                        <div className="w-100 position-relative file-upload-body">
                                            <div className={image && image.length > 0 ? "break-words" : "center-elements break-words"}>
                                                <div>
                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                </div>
                                                {
                                                    image.map((elem, ind) => {
                                                        return (
                                                            <div key={ind} className="file-photo">
                                                                <div>
                                                                    <span>{elem.name}</span>
                                                                </div>
                                                                <div className="flex w-1/4 p-l-5">
                                                                    <div className="cursor-pointer">  <i className="fa fa-times" aria-hidden="true" onClick={() => remove('image')}></i> </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div> :
                                        <label htmlFor="photo" className="w-100">
                                            <div className="w-100 position-relative file-upload-body cursor-pointer">
                                                <div className="center-elements break-words">
                                                    <div>
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </label>

                                }
                            </div>
                            <input type="file" id="photo"
                               accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                                className="display-none" name="photo"
                                onChange={(event) => handleFieldChange(event)} />
                        </div>
                        <div className="width-48">
                                <div>
                                    <div className="w-100 file-upload-header">
                                        Customer Signature
                                    </div>
                                    {
                                        signature && signature.length > 0 ?
                                            <div className="w-100 position-relative file-upload-body">
                                                <div className={signature && signature.length > 0 ? "break-words" : "center-elements break-words"}>
                                                    <div>
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                    </div>
                                                    {
                                                        signature.map((elem, ind) => {
                                                            return (
                                                                <div key={ind} className="file-photo">
                                                                    <div>
                                                                        <span>{elem.name}</span>
                                                                    </div>
                                                                    <div className="flex w-1/4 p-l-5">
                                                                        <div className="cursor-pointer">  <i className="fa fa-times" aria-hidden="true" onClick={() => remove('signature')}></i> </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div> :
                                            <label htmlFor="signature" className="w-100">
                                                <div className="w-100 position-relative file-upload-body cursor-pointer">
                                                    <div className="center-elements break-words">
                                                        <div>
                                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </label>

                                    }
                                </div>
                            <input type="file" id="signature"
                                accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                                className="display-none" name="signature"
                                onChange={(event) => handleFieldChange(event)} />
                        </div>
                    </div>
                    <div className="display-flex justify-content-space-around p-t-10">
                        <div className="width-48">
                                <div>
                                    <div className="w-100 file-upload-header">
                                        Customer ID Proof
                                    </div>
                                    {
                                        idproof && idproof.length > 0 ?
                                            <div className="w-100 position-relative file-upload-body">
                                                <div className={idproof && idproof.length > 0 ? "break-words" : "center-elements break-words"}>
                                                    <div>
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                    </div>
                                                    {
                                                        idproof.map((elem, ind) => {
                                                            return (
                                                                <div key={ind} className="file-photo">
                                                                    <div>
                                                                        <span>{elem.name}</span>
                                                                    </div>
                                                                    <div className="flex w-1/4 p-l-5">
                                                                        <div className="cursor-pointer">  <i className="fa fa-times" aria-hidden="true" onClick={() => remove('idproof')}></i> </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div> :
                                            <label htmlFor="idproof" className="w-100">
                                                <div className="w-100 position-relative file-upload-body cursor-pointer">
                                                    <div className="center-elements break-words">
                                                        <div>
                                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </label>

                                    }
                                </div>
                            <input type="file" id="idproof"
                                accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                                className="display-none" name="idproof"
                                onChange={(event) => handleFieldChange(event)} />
                        </div>
                        <div className="width-48">
                                <div>
                                    <div className="w-100 file-upload-header">
                                        Customer ECG Report
                                    </div>
                                    {
                                        ecgreport && ecgreport.length > 0 ?
                                            <div className="w-100 position-relative file-upload-body">
                                                <div className={ecgreport && ecgreport.length > 0 ? "break-words" : "center-elements break-words"}>
                                                    <div>
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                    </div>
                                                    {
                                                        ecgreport.map((elem, ind) => {
                                                            return (
                                                                <div key={ind} className="file-photo">
                                                                    <div>
                                                                        <span>{elem.name}</span>
                                                                    </div>
                                                                    <div className="flex w-1/4 p-l-5">
                                                                        <div className="cursor-pointer">  <i className="fa fa-times" aria-hidden="true" onClick={() => remove('ecgreport')}></i> </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div> :
                                            <label htmlFor="ecgreport" className="w-100">
                                                <div className="w-100 position-relative file-upload-body cursor-pointer">
                                                    <div className="center-elements break-words">
                                                        <div>
                                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </label>

                                    }
                                </div>
                            <input type="file" id="ecgreport"
                                accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                                className="display-none" name="ecgreport"
                                onChange={(event) => handleFieldChange(event)} />
                        </div>
                    </div>
                    <div className="text-align-center p-t-10">
                        <Button variant="success" className="cursor-pointer text-align-center width-40 border-curve-10" onClick={() => submitFiles()}> Submit </Button>
                    </div> */}
                </Modal.Body>
            </Modal>
        </div >
    );
};

export default FileUploadModal;
